// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const vacationTimeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVacationTimes: builder.query({
      query: (queryParams = {}) => {
        let _queryParams = {...queryParams};
        if (queryParams?.provider_ids) {
          _queryParams.provider_ids = queryParams.provider_ids.join(',');
        }
        const qs = new URLSearchParams(_queryParams).toString();
        return `vacation_time/?${qs}`;
      },
      providesTags: ['VacationTime', 'Event'],
    }),
    createVacationTime: builder.mutation({
      query: body => ({
        url: 'vacation_time/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['VacationTime', 'Event'],
    }),
    removeVacationTime: builder.mutation({
      query: ({ id }) => ({
        url: `vacation_time/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VacationTime', 'Event'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetVacationTimesQuery,
  useCreateVacationTimeMutation,
  useRemoveVacationTimeMutation
} = vacationTimeApi;
